import Layout from "../pages/layout/layout";
import Home from "../pages/home_page/home";
import MoviePage from "../pages/movie_page/moviePage";
import ContactUs from "../pages/contact_us_page/contactUs";
import FAQ from "../pages/faq_page/faq";
import TermsPage from "../pages/terms_conditions/terms";
import PrivacyPage from "../pages/privacy/privacy";
import { Route, Routes } from "react-router-dom";
import MyTickets from "../pages/my_tickets/myTickets";

const RootRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="/movie" element={<MoviePage />}>
          <Route path=":movieId" element={<MoviePage />} />
          <Route path=":movieId/:cinemaId" element={<MoviePage />} />
        </Route>
        <Route path="/tickets" element={<MyTickets />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
      </Route>
    </Routes>
  );
};
export default RootRoutes;
